import React, { FC, forwardRef } from 'react';
import classnames from 'classnames';
import './index.less';

export type BgNameType = 'common' | 'special' | 'light' | 'common-icons';

interface BgImgProps {
  bgName?: BgNameType;
}

const BgImg = ({ bgName = 'common' }, ref) => {
  return (
    <div
      ref={ref}
      id="bgImg"
      className={classnames('bg-img', {
        'bg-img-common': bgName === 'common',
        'bg-img-special': bgName === 'special',
        'bg-img-light': bgName === 'light',
        'bg-img-common-icons': bgName === 'common-icons',
      })}
    />
  );
};
export default forwardRef<HTMLDivElement, BgImgProps>(BgImg);
